import React, { useState, useEffect } from 'react';
import styles from '../styles/DecisionTool.styles';
import SegmentPreferenceIndex from './SegmentPreferenceIndex';
import SegmentInfo from './SegmentInformation';

const ManufacturingTable = ({
    attributesList,
    selectedLevels,
    tradeoffMatrix,
    handleLevelChange,
    totalSum,
    upgradedBikeValues,
    manufacturedBikeValues,
}) => {
    const [showSegmentPreference, setShowSegmentPreference] = useState(false);
    const [showSegmentInfo, setShowSegmentInfo] = useState(false);

    // State to track error message visibility
    const [isError, setIsError] = useState(false);

    // Toggle functions for collapsible sections
    const toggleSegmentPreference = () => {
        setShowSegmentPreference((prev) => !prev);
    };

    const toggleSegmentInfo = () => {
        setShowSegmentInfo((prev) => !prev);
    };

    // Effect to check if totalSum exceeds 25 and set error state accordingly
    useEffect(() => {
        if (totalSum > 25) {
            setIsError(true); // Show error if total exceeds 25
        } else {
            setIsError(false); // Hide error if total is 25 or below
        }
    }, [totalSum]); // Only run when totalSum changes

    return (
        <div>
            <div className={styles.headerContainer}>
                <h2>Manufacturing</h2>
                <button onClick={toggleSegmentPreference} className={styles.toggleButton} style={{ marginBottom: '10px' }} >
                    {showSegmentPreference ? 'Hide Population size and Preference Overview' : 'View Population size and Preference Overview'}
                </button>
                <button onClick={toggleSegmentInfo} className={styles.toggleButton} style={{ marginBottom: '20px', marginLeft: '5px' }} >
                    {showSegmentInfo ? 'Hide Advertising Cost by Audience' : 'View Advertising Cost by Audience'}
                </button>
            </div>

            {
                showSegmentPreference && (
                    <div className={styles.collapsibleSection}>
                        <SegmentPreferenceIndex />
                    </div>
                )
            }
            {
                showSegmentInfo && (
                    <div className={styles.collapsibleSection}>
                        <SegmentInfo />
                    </div>
                )
            }

            <p>Make your selection for each bike attribute based on your analysis of the Cuban Bike Market and the corresponding tradeoffs.</p>
            <p>A budget of 25 manufacturing credits is given for initial design. Bike manufacturing only occurs in Period 1.</p>

            <table className={styles.tradeoffTable}>
                <thead>
                    <tr>
                        <styles.att>Attribute</styles.att>
                        <styles.th>Selection</styles.th>
                        {attributesList.map((columnAttribute) => (
                            <styles.th key={columnAttribute}>{columnAttribute}</styles.th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {attributesList.map((rowAttribute) => (
                        <tr key={rowAttribute}>
                            <styles.field2>{rowAttribute}</styles.field2>
                            <styles.td>
                                <select
                                    value={selectedLevels[rowAttribute]}
                                    onChange={(e) => handleLevelChange(rowAttribute, e.target.value)}
                                >
                                    {[1, 2, 3, 4, 5].map((option) => (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                            </styles.td>
                            {attributesList.map((columnAttribute) => (
                                <styles.td key={columnAttribute}>
                                    {tradeoffMatrix.attributes[rowAttribute].tradeoffs[columnAttribute][selectedLevels[rowAttribute] - 1]}
                                </styles.td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>

            {upgradedBikeValues && (
                <div>
                    <p> </p>
                    <h3>Manufactured Bike Attributes</h3>
                    <table className={styles.tradeoffTable}>
                        <thead>
                            <tr>
                                <styles.att2>Attribute</styles.att2>
                                {attributesList.map((attribute) => (
                                    <styles.th key={attribute}>{attribute}</styles.th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <styles.field> Manufactured Bike </styles.field>
                                {attributesList.map((columnAttribute) => (
                                    <styles.td key={columnAttribute}>{manufacturedBikeValues[columnAttribute]}</styles.td>
                                ))}
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}

            <div>
                <p></p>
            </div>

            <div className={styles.totalContainer}>
                <styles.label>TOTAL MANUFACTURING COST :</styles.label>
                <styles.sumInput
                    type="text"
                    value={totalSum}
                    readOnly
                    style={{ color: isError ? 'red' : 'darkgreen' }} // Change color based on error
                />
                {isError && (
                    <span style={{ color: 'red', marginLeft: '10px' }}>
                        ERROR: Manufacturing Budget (25) Exceeded
                    </span>
                )}
            </div>

        </div >
    );
};

export default ManufacturingTable;
